<template>
  <div>
    <div v-show="!hiddenVariable.dialogColumnVisible" class="schoolCardList-container div-layout">
      <module-title title="视频分类">
        <div class="right">
          <el-button type="primary" size="medium" @click="columnAddOrEdit('add')">
            类型添加
          </el-button>
        </div>
      </module-title>
      <div class="schoolCardList-right-contain">
        <el-form
          ref="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="视频类型：" prop="typeName">
            <el-input
              v-model="searchForm.typeName"
              name="typeName"
              auto-complete="off"
              size="medium"
              maxlength="20"
              class="edit-form-input"
              placeholder="输入视频类型"
              clearable
            />
          </el-form-item>
          <el-form-item style="margin-left:50px;">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="videoTypeList"
          fit
          element-loading-text="Loading"
          class="list-table"
          highlight-current-row
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="视频类型" align="center" prop="typeName" />
          <el-table-column label="添加时间" prop="updateDate" align="center" />
          <el-table-column label="操作" align="left" width="210px">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="columnAddOrEdit('edit',scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="danger"
                size="small"
                icon="el-icon-view"
                @click="handleDel(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
      <!-- 添加编辑 -->
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogEditVisible"
        :title="hiddenVariable.handleTitle==='add'?'添加':'编辑'"
        width="450px"
      >
        <el-form
          ref="handleForm"
          :model="handleForm"
          :rules="handleRules"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="视频类型名称" prop="typeName">
            <el-input
              v-model="handleForm.typeName"
              name="typeName"
              maxlength="8"
              placeholder="请输入视频类型名称"
              class="handle-form-input"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="hiddenVariable.dialogEditVisible = false">
            取消
          </el-button>
          <el-button
            :loading="ajaxLoading"
            type="primary"
            size="medium"
            @click="handleAddColumn"
          >
            {{ ajaxLoading?'Loading':'确定' }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
// 获取API
import {
  getVideoTypeList,
  getVideoTypeAdd,
  getVideoTypeEdit,
  getVideoTypeDelete
} from '@/api/productOperation/common/applicationManage';
export default {
  name: 'ModuleIntroduction',
  data() {
    const validatTypeName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('视频类型名称不能为空'));
      } else if (value.toString().length > 6) {
        callback(new Error('请输入6以内字符'));
      } else {
        callback();
      }
    };

    return {
      videoTypeList: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        typeName: '',
        total: 0
      },
      listLoading: false,
      ajaxLoading: false,
      hiddenVariable: {
        columnId: '',
        dialogColumnVisible: false,
        dialogEditVisible: false, // 添加编辑
        handleTitle: 'add',
        id: ''
      },
      handleForm: {
        typeName: ''
      },
      handleRules: {
        typeName: [{ required: true, validator: validatTypeName, trigger: 'blur' }]
      }
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.fetchVideoTypeList();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchVideoTypeList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchVideoTypeList();
    },

    // 编辑文本框变化
    editorChangeFn(val) {
      this.handleForm.content = val;
    },

    editorChangeTextFn(val) {
      this.handleForm.remark = val;
      this.handleForm.editorText = val;
    },

    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchVideoTypeList();
    },

    // 获取列表
    fetchVideoTypeList() {
      this.listLoading = true;
      var option = {
        ...this.searchForm
      };
      delete option.total;
      getVideoTypeList(option).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.videoTypeList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.videoTypeList = [];
        }
        this.listLoading = false;
      });
    },
    // 添加加编辑
    columnAddOrEdit(val, row) {
      this.hiddenVariable.dialogEditVisible = true;
      this.hiddenVariable.handleTitle = val;
      if (val === 'edit') {
        this.handleForm = {
          typeName: row.typeName
        };
        this.hiddenVariable.id = row.id;
      } else {
        this.handleForm = {
          typeName: '',
          columnNum: '',
          // v17.1
          introduction: ''
        };
        this.hiddenVariable.id = '';
      }
    },
    // 删除
    handleDel(row) {
      this.$confirm(
        `确定将该视频分类删除？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          getVideoTypeDelete(row.id)
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: '操作成功',
                showClose: false,
                duration: 2000
              });
              this.fetchVideoTypeList();
            })
            .catch(err => {
              console.log(err);
            });
        });
    },
    // 添加确认
    handleAddColumn() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          if (this.hiddenVariable.handleTitle === 'add') {
            var op = {
              typeName: this.handleForm.typeName,
              createUserCode: this.userInfo.code
            };
            getVideoTypeAdd(op)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '新增成功',
                  showClose: false,
                  duration: 2000
                });
                this.hiddenVariable.dialogEditVisible = false;
                this.fetchVideoTypeList();
              })
              .catch(err => {
                console.log(err);
              });
            this.ajaxLoading = false;
          } else {
            var op1 = {
              typeName: this.handleForm.typeName,
              updateUserCode: this.userInfo.code
            };
            getVideoTypeEdit(op1, this.hiddenVariable.id)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.hiddenVariable.dialogEditVisible = false;
                this.fetchVideoTypeList();
              })
              .catch(err => {
                console.log(err);
              });
            this.ajaxLoading = false;
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.schoolCardList-container {
    .textCenter{text-align: center;padding: 20px;
    .el-button {
      width: 160px;
    }
  }
  // .handle-form-input{ width: 160px;}
  // 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .red{color: red;}
  .warning{
    margin: 20px 20px 0 0 ;
    padding: 8px 16px;
    border-radius: 4px;
    background-color: #fdf6ec;
    color: #e6a23c;}
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
